import { render, staticRenderFns } from "./StudioQuiz.vue?vue&type=template&id=21020cc4&scoped=true&"
import script from "./StudioQuiz.vue?vue&type=script&lang=js&"
export * from "./StudioQuiz.vue?vue&type=script&lang=js&"
import style0 from "./StudioQuiz.vue?vue&type=style&index=0&id=21020cc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21020cc4",
  null
  
)

export default component.exports